import React, { useEffect } from 'react';
import { Button, Input } from 'reactstrap';

export default function ScoreCard(props) {
  useEffect(() => {}, [props.currentScore, props.gameOver]);
  function handleSubmit(e) {
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());    
    let newScore = {
      'player_score' : props.currentScore, 
      'player_name' : formJson['playerName'].slice(0, 25)
    } 
    props.submit(newScore);
    e.preventDefault();    
  }
  return (
    <div className="scorecard">
      {props.gameOver === false ? (
        <>
          <p>Your Score : {props.currentScore}</p>
          <Button color="primary" key="btnReset" onClick={() => props.reset()}>
            Reset
          </Button>
        </>
      ) : (
        <form method="post" onSubmit={handleSubmit}>
          <p>Game Over</p>
          <p>Final Score : {props.currentScore}</p>
          <div className="row">
            <div className="col  col-9">
              <Input name="playerName" placeholder="Enter Your Name"></Input>
            </div>
            <div className="col col-3">
              <Button
                color="primary"
                key="btnSubmit"
                type="submit"                
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}
